"use client";

import { c as _c } from "react/compiler-runtime";
import { AvailabilityEnum } from "@sprawdzonabron/shared";
import { TestIdEnum } from "../../../tests/types";
import { getAvailabilityText } from "./utils";
interface AvailabilityProps {
  availability: AvailabilityEnum;
}
export const AvailabilityInfo = t0 => {
  const $ = _c(5);
  const {
    availability
  } = t0;
  const textColorClass = availability === AvailabilityEnum.Yes ? "text-green-600 dark:text-green-400" : availability === AvailabilityEnum.No ? "text-red-600 dark:text-red-400" : "text-orange-600 dark:text-orange-400";
  const t1 = `font-semibold ${textColorClass}`;
  let t2;
  if ($[0] !== availability) {
    t2 = getAvailabilityText(availability);
    $[0] = availability;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <div className="text-xs text-slate-500 dark:text-slate-400 ml-1" data-testid={TestIdEnum.ProductAvailability}><span className={t1}>{t2}</span></div>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};